//import zhLocale from 'element-plus/dist/locale/zh-cn.mjs'
//import { valueEquals } from 'element-plus'
import zhLocale from 'element-plus/dist/locale/zh-cn'   
 
// zh-CN.js
export default {
  ...zhLocale, // Element Plus 中文包
  message: {
    login: {
      title: '磁台云登录',
      username: '用户名',
      password: '密码',
      loginBtn: '登录',
      rememberChek: '记住用户名',
      client:"客户平台",
      server:"管理平台",
      usernameRequired: '请输入用户名',
      passwordRequired: '请输入密码',
      success: '登录成功',
      failed: '登录失败，请检查用户名和密码',
      fillAllFields: '请填写所有必填字段',
      httpError: 'HTTP错误! 状态码:',
      invalidResponse: '无效的响应格式'
    },
    request:{
      tokenExpired:"会话过期,请重新登录",
    },
    system: {
      title: '磁台云控制台'
    },
    rtu: {
      title: 'RTU状态',
      tabStatus: '状态',
      tabSetpoints: '设定值',
      lastUpdated: '最近更新',
      live: '实时',
      refresh: '刷新',
      refreshing: '刷新中…',
      refreshed: '已发送点名，正在从设备读取',
      refreshFailed: '刷新失败',
      stale: '已过期',
      staleData: '数据已过期（最后更新 {time}），请刷新。',
      alarmBanner: '{n} 条活动报警',
      checkFdd: '查看FDD',
      liveSection: '实时状态',
      updatesEvery: '每 5 秒更新',
      roomTemp: '室内温度',
      oat: '室外温度',
      sat: '送风温度',
      fanSpeed: '风机频率',
      compSpeed: '压缩机',
      damper: '风阀',
      power: '功率',
      indoorFanChip: '室内风机',
      y1: '压缩机 Y1',
      y2: '压缩机 Y2',
      w1: '加热器 W1',
      w2: '加热器 W2',
      occupiedChip: '有人',
      on: '开',
      off: '关',
      healthSection: '健康状态 (FDD)',
      healthHint: '绿=正常 · 红=报警 · 灰=无数据',
      comfortGroup: '能耗与舒适',
      statusGroup: '状态与报警',
      alarmTag: '报警',
      ind: {
        energy: '能耗', demand: '需量', cooling: '制冷', heating: '制热',
        iaq: '空气质量', humidity: '湿度',
        economizer: '经济器', indoorFan: '室内风机/盘管',
        outdoorFan: '室外风机/盘管', compressor: '压缩机', heaters: '加热器',
        vfd: '变频器', sensors: '传感器'
      },
      schedSection: '在室时间表',
      schedHint: '应用于本机组',
      day: '星期',
      occupiedFrom: '在室开始',
      occupiedUntil: '在室结束',
      smartRecovery: '智能预启',
      days: { mon: '周一', tue: '周二', wed: '周三', thu: '周四', fri: '周五', sat: '周六', sun: '周日' },
      modified: '已修改',
      holidays: '节假日',
      openSlots: '{n} 个空位',
      unoccupiedAllDay: '全天无人',
      changesPending: '{n} 项待应用修改',
      writesOnlyChanged: '仅写入修改过的日期',
      noChanges: '暂无修改',
      discard: '放弃',
      reviewApply: '确认并应用',
      reviewTitle: '应用时间表修改？',
      reviewBody: '以下日期将写入机组：',
      applyConfirm: '应用',
      cancel: '取消',
      schedApplied: '时间表已写入并确认',
      schedBothTimes: '{day}：开始与结束时间需同时设置或同时清空',
      schedStartBeforeEnd: '{day}：开始时间必须早于结束时间',
      historySection: '历史数据',
      historyHint: '设定值与实际 · 运行状态 · 故障',
      range24h: '24小时',
      range7d: '7天',
      range30d: '30天',
      seriesSetpoint: '设定值',
      seriesRoom: '室内温度',
      faultEvent: '故障事件',
      runStates: '运行状态',
      lanes: { fan: '风机', compressor: '压缩机', heat: '制热', occupied: '有人' },
      spHint: '写入机组后读回确认',
      occHeat: '有人制热',
      occCool: '有人制冷',
      unoccHeat: '无人制热',
      unoccCool: '无人制冷',
      fanMode: '风机',
      auto: '自动',
      occupiedOpt: '有人',
      unoccOpt: '无人',
      fanOnOpt: '常开',
      apply: '应用修改',
      applying: '写入中…',
      applied: '读回已确认',
      spApplied: '设定值已写入并确认',
      writePending: '已下发——等待设备回报新数值（真实网关可能需要几分钟）',
      writeConfirming: '已下发——正在与设备确认…',
      spConfirmed: '设定值已被设备确认',
      confirmingNote: '正在与设备确认…',
      writeUnmapped: '未写入——以下寄存器在该机组未配置，请检查模板变量映射：{vars}',
      noSpData: '该机组未上报任何设定值——变量映射可能未配置完整',
      schedMappingIncomplete: '部分时间表寄存器在该机组未配置——对应单元格已禁用。请检查模板变量映射。',
      spStagedNote: '修改先暂存 — 点击"应用修改"后才会写入。写入后将读回机组实际值并显示。',
      writeFailed: '写入失败',
      deadbandError: '制热与制冷设定值至少需相差 {n}°F',
      deadbandNote: '制热与制冷设定值保持至少 {n}°F 间隔 — 超出限制的数值在写入前会被拦截。',
      modeNow: '当前模式',
      activeSetpoint: '当前设定值',
      loadFailed: '设备数据加载失败',
      opMode: '运行模式',
      // OMC 枚举（2C V4 固件，Changlin 2026-07-17 确认）
      modes: {
        0: '未知', 1: '消防锁定', 2: '停机', 3: '通风',
        4: '制热', 5: '制冷'
      },
      series: { sp: '设定值', room: '室内温度', oat: '室外温度', sat: '送风温度' },
      exportCsv: '导出CSV',
      fleetTitle: 'RTU概览',
      fleetName: 'RTU',
      fleetCompressor: '压缩机',
      fleetHeater: '加热器',
      fleetNoData: '暂无数据上报',
      stage1: '一级',
      stage2: '二级',
      groupMember: '分组 {g}。',
      groupPropagates: '此处输入为组基准值 —— 每台机组写入 基准值+各自偏置：',
      groupSelf: '本机',
      groupApplied: '已联动更新 {n} 台同组 RTU',
      groupEditTitle: 'RTU 分组',
      groupEditHint: '同组 RTU 共享温度设定值以实现分级。某台设定值变更时，其余成员被设为该值加上各自偏置（°F）。分组 0 表示未分组。',
      groupCol: '分组',
      offsetCol: '偏置 °F',
      groupLocalNote: '保存在本浏览器（覆盖共享默认值）。如需对所有用户生效，请让管理员写入共享配置。',
      groupReset: '恢复共享默认',
      groupSaved: '分组已保存（本浏览器）',
      groupResetDone: '已恢复共享默认',
      groupLabel: '分组 {g}',
      ungroupedLabel: '未分组',
      groupCount: '{n} 台',
      effTip: '本机实际写入值（组基准 + 本机偏置）',
      fleetSetpoints: '设定值 热/冷',
      spOcc: '有人',
      spUnocc: '无人',
      fleetSetpointsTip: '本机当前时段实际持有的制热/制冷设定值（分组机组显示各自错峰值）'
    },
    menu: {
      navigation: '导航栏',
      dashboard: '仪表盘',
      system: '系统管理',
      company: '组织管理',
      user: '用户管理',
      role: '角色管理',
      operationLog: '操作日志',
      settings: '系统设置',
      device: '设备管理',
      deviceList: '设备列表',
      deviceTemplate: '设备模板',
      gateway: '设备网关',
      dataCenter: '数据中心',
      realtimeData: '实时数据',
      realtimePlot: '实时plot',
      history: '历史记录',
      alarms: '报警记录',
      id:"序号",
      clientDevice: '项目',
      message:"消息",
      account:"用户",
      project:"项目选项",
      projectList:"项目列表",
    },
    common: {
      langChanged: '语言已更改',
      langChangeFailed: '语言更改失败',
      profileDeveloping: '正在开发个人资料',
      logoutConfirm: '确认注销',
      tip: '提示',
      confirm: '确认',
      cancel: '取消',
      noToken: '没有令牌',
      httpError: 'HTTP 错误',
      logoutSuccess: '注销成功',
      logoutFailed: '注销失败',
      logoutCancelled: '注销已取消',
      logoutError: '注销错误',
      warning:'警告',
      saveSuccess: "保存成功",
      saveFailed: "保存失败",      
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      deleteCancelled: '已取消删除',
      updateSuccess: '更新成功',
      addSuccess: '新增成功',
      submitError: "提交错误",      
      fetchError: "获取错误",      
      error:'异常',
      edit:"编辑",
      delete:"删除",
      search:"搜索",
      total: "共 {total} 条",
      goto:"前往",
      page:"页",
      reset:"重置",
      noData:"无数据",
      loading:"正在加载",      
      loadFailed:"加载失败",      
      exit:"返回",      
      success:"成功",    
        failed:"失败",        
        info:"信息",
        save:"保存",
        gridView:"图标示图",
        listView:"列表示图"
    },
    dashboardMsg: {
      welcomingSpeech:"欢迎使用磁台管理系统",
      currentTime: "当前时间",
      dashboardName: "仪表盘",
      locale:"zh-CN",
    },
     "underConstruction": {
      "title": "建设中",
      "description": "网页正在积极建设中，请稍后访问。"
    },
     "organization": {
        "title": "组织管理",
        "add": "新增组织",
        "edit": "编辑组织",
        "structure": "组织结构",        
        "namePlaceholder": "请输入组织名称",        
        "addMessage": "添加组织功能",
        "editMessage": "编辑组织: {name}",
        "deleteConfirm": "确认删除组织 \"{name}\" 吗？",
        "editNodeMessage": "编辑节点: {label}",
        "deleteNodeConfirm": "确认删除节点 \"{label}\" 吗？",
        "company":"所属组织",
        "inputName":"请输入组织名称",
          "parentCompany":"上级组织",
          "selectCompany":"请选择组织",                    
          "inputDescribe":"请填写强织描述不超过50个字符",          
          "id":"序号",
          "parent": "上级组织",
          "name": "组织名称",
          "describe": "组织描述",
          "createdAt": "创建时间",
          "actions": "操作",
          "contact":"联系人",          
          "phone":"电话",          
          "location":"地址",          
          "inputContact":"请输入联系人",          
          "inputPhone":"请输入电话",          
          "inputLocation":"请输入地址",         
            "nameRequired":"请输入组织名称",         
            "companyRequired":"请选择上级组织",       
            "noData":"无数据",
            "deleteSuccess": '删除成功',
      "deleteFailed": '删除失败,请先解除绑定',
      "deleteCancelled": '已取消删除',
      "updateSuccess": '更新成功',
      "updateFailed": '编辑失败',
      "addSuccess": '新增成功',
      "addFailed": '新增失败,存在重复或者其它原因请查看数据',
      "operationFailed":"操作失败",
      "rootCompany":"顶级组织",
      },
    "users": {
      "title": "用户管理",
        "add": "新增用户",
        "edit": "编辑用户",        
        "name": "用户名称",
        "inputName":"请输入用户名称",
        "organization": "所属组织",
        "role": "角色",
        "creator":"创建人",
        "createdAt":"创建时间",
        "state":"状态",
        "actions":"操作",
        "noData":"无数据",
        "loadListFailed":"加载列表失败",
        "changePassword":"修改密码",
        "oldPassword":"原密码",
        "newPassword":"新密码",
        "password":"密码",
        "confirmPassword":"确认密码",
        "inputPassword":"请输入密码",
        "inputConfirmPassword":"请输入确认密码",
        "associatRole":"关联角色",
        "associatOrganization":"关联组织",
        "selectCompany": '请选择企业',
        "selectRole":"请选择角色",
        "nameRequired":"请输入用户名",
        "passwordRequired":"请输入密码",
        "oldPasswordRequired":"请输入原密码",
        "confirmPasswordRequired":"请输入确认密码",
        "companyRequired":"请选择组织",
        "roleRequired":"请选择角色",        
        "inputOldPassword":"请输入原密码",
        "inputNewPassword":"请输入新密码",
        "addSuccess":"增加成功",      
        "addFailed":"增加失败,请检查输入信息",
        "passwordNotMatch":"两次输入的密码不一致",
            "passwordNull":"密码不能为空",        
           "passwordMinLength": "密码长度不能少于6位",
           "operationFailed":"数据异常，请检查数据",
           "updateSuccess":"更新成功",
           "updateFailed":"更新失败",       
           "deleteSuccess":"删除成功",       
           "deleteFailed":"删除失败",                  
           "deleteConfirm": "确认删除用户 \"{name}\" 吗？",
           "DisableConfirm": "确认禁用用户 \"{name}\" 吗？",
           "langType":"语言类型",
           "langTypeRequired":"请选择语言",
           "editLang": "编辑语言",
      "langUpdateSuccess": "语言修改成功",
      "langUpdateFailed": "语言修改失败"
                 
    },  
    user: {
      guest: '访客',
      profile: '个人中心',
      logout: '退出登录'
    },
    "role":{
      "title": "角色管理",
      "add": "添加",
      "edit": "编辑",
      "id": "角色ID",
      "name": "角色名称",
      "nameEn": "英文名称",
      "description": "角色描述",
      "userCount": "关联用户数",
      "actions": "操作",
      "menuConfig": "菜单权限配置",
      "inputName": "请输入角色名称",
      "inputNameEn": "请输入英文名称",
      "inputDescription": "请输入角色描述",
      "nameRequired": "请输入角色名称",
      "nameLength": "角色名称长度在2-30个字符之间",
      "nameEnLength": "英文名称不能超过60个字符",
      "descriptionLength": "角色描述不能超过100个字符",
      "loadFailed": "加载角色列表失败",
      "addSuccess": "添加角色成功",
      "editSuccess": "编辑角色成功",
      "updateSuccess": "更新角色成功",
      "deleteSuccess": "删除角色成功",
      "addFailed": "添加角色失败",
      "updateFailed": "更新角色失败",
      "deleteFailed": "删除角色失败",
      "submitFailed": "提交表单失败",
      "deleteConfirm": "确定要删除角色 \"{name}\" 吗？",
      "loadMenuFailed": "加载菜单数据失败",
      "menuConfigSuccess": "菜单权限配置成功",
      "menuConfigFailed": "菜单权限配置失败",
      "save": "保存"
    },
    "operationLog":
    {
          "company":"所属企业",
      "selectCompany": '请选择企业',
        "inputName":"请输入操作人员",
        "loadListFailed":"加载列表失败",
      "title":"操作日志",      
      "inputContents":"请输入操作内容",
      "id":"序号",      
      "companyName":"所属企业",
      "name":"操作人员",
      "contents":"操作内容",
      "result":"操作结果",
      "createdAt":"操作时间",
       "timeRange":"时间范围",          
      "startTime":"开始时间",
        "endTime":"结束时间",        

    },
    gateway: {
      title: '网关管理',
      add: '新增网关',
      edit: '编辑',
      delete: '删除',
      company: '所属企业',
      name: '网关名称',
      status: '状态',
      imei: 'IMEI号',
      sn: 'SN码',
      manufacturer: '厂家类型',
      protocol: '协议类型',
      createTime: '创建时间',
      actions: '操作',
      all: '全部',
      offline: '离线',
      online: '在线',
      search: '查询',
      reset: '重置',
      selectCompany: '请选择企业',
      inputName: '请输入网关名称',
      selectStatus: '请选择状态',
      nameRequired: '请输入网关名称',
      companyRequired: '请选择企业',
      imeiRequired: '请输入IMEI号',
      snRequired: '请输入SN码',
      manufacturerRequired: '请选择厂家类型',
      protocolRequired: '请选择协议类型',
      description: '网关描述',
      inputDescription: '请输入网关描述',
      selectManufacturer: '请选择厂家类型',
      selectProtocol: '请选择协议类型',
      cancel: '取消',
      confirm: '确定',
      addTitle: '新增网关',
      editTitle: '编辑网关',
      deleteConfirm: '确认删除该网关吗?',
      tip: '提示',
      deleteSuccess: '网关删除成功',
      deleteFailed: '网关删除失败',
      deleteCancelled: '已取消删除',
      updateSuccess: '网关更新成功',
      addSuccess: '网关新增成功',
      addFailed: '网关新增失败',
      loadDataFailed: '获取数据失败',
      loadCompanyFailed: '加载企业数据失败',
        manufacturer1: 'usr-M300-Eg228',
      manufacturer2: 'LanFeng-LF220',
      manufacturer3: 'usr-Else'
    },
    template:
    {
      title: '模板管理',
      add: '新增模板',
      edit: '编辑',
      delete: '删除',
      company: '所属企业',
      search: '查询',
      reset: '重置',
      selectCompany: '请选择企业',
      inputName: '请输入模板名称',
      id:"序号",
      name:"模板名称",      
      getType: "采集方式",
      getTypeA: "云端轮循",
      getTypeB: "边缘采集",
      varTotal: "变量总数",
      deviceTotal:"关联设备数",
      stateType: "状态配置",
      stateTypeA: "网关",
      stateTypeB: "设备数据",
      createTime: "创建时间",
      subUser: "子用户",
      slaveConfig: "从设备配置",
      variableConfig:"变量配置",
      actions: '操作',
      cancel: '取消',
      confirm: '确定',
      addTitle: '新增设备模板',
      editTitle: '编辑设备模板',
      deleteConfirm: '确认删除该设备模板吗?',
      fetchError: "获取错误",
      deleteSuccess: '模板删除成功',
      deleteFailed: '模板删除失败',
      deleteCancelled: '已取消删除',
      updateSuccess: '模板更新成功',
      addSuccess: '模板新增成功',
      submitError: "提交错误",
      nameRequired: '请输入模板名称',
      companyRequired: '请选择企业',
      getTypeRequired: '请选择采集方式',
      save:"保存",
      saveFailed:"模板保存失败,请查看是否存在重名",
      saveSuccess: "模板保存成功",
      updateFailed:"模板更新失败,请查看是否存在重名",
      validate:   "请输入正确模板数据",
      noDataReturned: "无数据返回",
      selectCompanyFirst:"请选择企业",
    },
    slave:
    {
        tabName:"从设备名称",
        protocol:"协议",
        addVariable:"增加变量",
        searchByName: "变量名",        
        queryVariable:"查询",
       importVariables:"导入变量",
       exportVariables:"导出变量",
       importUpdateVariables:"更新变量",
       importUpdateSuccess:"导入更新成功",
       importUpdateTip:"更新提示",
       batchDelete:"批量删除",
       keepOneTab:"保留一个从设备",
       completeCurrentTab:"完成当前选项卡",
       addSlave:"添加从设备",
       confirmDeleteTab:"删除从设备",
       varName:"变量通讯名称",
       display_name:" 变量显示名称",
       variableInputDisplayName:"请输入显示名称", 
        description:"变量描述",
          InputDescription:"请输入变量描述",
           name_group:"变量分组",
           groupSort:"分组排序",
             groupName:"组名",
             groupSortTip:"组排序提示",
             groupSorts:"分组排序",
             inputGroupName:"请输入组名",
       VariabledataType:"变量数据类型",
       varType:"变量类型",
       valueType:"数值类型",
         rwType:"读写",
     storageMode:"存储方式",
     actions: '操作',
     register:"寄存器",
     completeRequiredFields:"填写必填从设备字段",
     createSuccess: "从设备增加成功",
     updateSuccess:"从设备更新成功", 
     createFail: "从设备增加失败，请查看是否存在重名",
     updateFail:"从设备更新失败，请查看是否存在重名",      
     deleteSuccess: '从设备删除成功',
     deleteFailed: '从设备删除失败,已经绑定设备,请先解除绑定设备',
      editVariable: "编辑变量",
      basicInformation:"基本信息",
      descriptionInformation:"描术信息",
          registerConfig:"寄存器配置",
    dataTypeConfig:"数据类型配置",
    dataValueConfig: "数据值配置",
      registerType: "寄存器类型",
      addressOne: "地址",
      addressTwo: "地址2",
      addressThree: "地址3",
      addressFour: "地址4",
      addressFive: "地址5",
      addressSix: "地址6",
      addressDecimal: "地址小数位",
      registerNum: "寄存器数量",
      timedStorageFreq: "定时存储频率",
      changeStorageVal: "变化存储值",
      varFlag: "变量标志",
      unit: "单位",
      value:"默认值",
       mult:"乘法",
    minimum: "最小值",
    maximum:"最大值",
      variableSaved: "变量保存成功",
      variableSaveFailed:"变量保存失败,请查看是否有重名",
      variableUpdateFailed:"变量更新失败",
      variableDeleted:"变量删除成功",      
      variableDeleteFailed:"变量删除失败",
      variableInputName: "请输入变量通讯名称",          
      dragFileHere: "将文件拖到此处",
      clickToUpload: "或点击上传",
      supportedFileTypes: "支持文件类型",
      selectFileFirst: "请先选择文件",
      tabNotFound: "未找到从设备Tab",
      importSuccess: "导入成功",
      importing: "正在导入",
      importFailed: "导入失败",
      exportSuccess: "导出成功",
      exportFailed: "导出失败",
      exportError: "导出错误",
      exportDataError: "响应不是有效的文件数据",
      confirmDeleteVariables:"确认删除变量",
      interval:"间隔",
      variableTypeA: "直采型变量",
      variableTypeB: "运算型变量",
      variableTypeC: "录入型变量", 
       rwTypeRW: "读写",
       rwTypeR: "只读",
       rwTypeW: "只写",
       storageModeOptionA: "全部存储",
      storageModeOptionB: "变化存储",
      variableUpdateSuccess: "变量更新成功",
      "batchUpdateGroupSort":"更新排序",
      "groupSortUpdateSuccess":"分组排序更新成功",
      "groupSortUpdateFailed":"分组排序更新失败",
      "groupSortConfig":"组排序配置",
    
    },
    clientProject:{
      "monitor"   :"监控",  
      "title"     :"项目列表",  
      "search"    :"搜索",
      "reset"     :"重置",
      "add"       :"新增",
      "edit"      :"编辑",
      "id"        :"序号",
      "name"      :"项目名称",
      "company"   :"所属公司",
      "state"     :"所属公司",
      "location"  :"项目位置",
      "description":"项目描述",
      "createTime":"创建时间",
      "actions"   : "操作",
      "inputName" :"请输入项目名称",
        "online"  : "部分在线",
        "Allonline"  : "在线",
        "offline" :"离线",
   "deleteSuccess": '删除成功',
    "deleteFailed": '删除失败',
 "deleteCancelled": '已取消删除',
    "deleteConfirm": "确认删除项目 \"{name}\" 吗？",
     "addProjectTitle":"新增项目信息",
     "editProjectTitle":"编辑项目监控信息",
     "RealTimeMonitor":"实时监控",
     "switchedToMode": "已切换到{mode}组",
    },
    "ClientProjectMonitor":
    {
        SystemMonitoring:"参数选项",        
      systemSettings: "系统设置", 
      systemDebug: "系统调试",
      energyAnalysis: "能耗分析",
      historyReports: "历史报表",
      eventManagement: "事件管理",
      psp: "PSP",
      outdoorLargeIceMachine: "室外大冰机",
      outdoorSmallIceMachine: "室外小冰机", 
      indoorLargeIceMachine: "室内大冰机",
      indoorSmallIceMachine: "室内小冰机",
      enterFullscreen: "全屏显示",
      exitFullscreen: "退出全屏", 
      enteredFullscreen: "已进入全屏模式",
      exitedFullscreen: "已退出全屏模式",
      fullscreenFailed: "全屏请求失败",
      switchedToMode: "已切换到{mode}模式",
      switchedToPage: "切换到{page}",
      unknown: "未知",
      unknownPage: "未知页面",
            noBusinessData: "未找到业务数据",
      loadBusinessSuccess: "成功加载 {count} 个业务选项",
      loadBusinessFailed: "加载业务选项失败"
      
    },
    "ClientProjectMonitorSystemMonitoring":
    {
        "configuration":"系统图",
        "operation":"运行参数",
        "alarm":"报警",
             "setup":"系统设置",
             "advanced":"强制参数",
             "noData":"无数据",
             "loadFailed":"加载失败",
    },
    "ClientProjectMonitorSystemMonitorParmater":
    {
      "loadFail":"加载失败",
      "queryAllData":"全部数据",
      "queryData":"查询数据",
       "track":"刷新设置",            
        "stopTrack":"停止更新设置",
        "connectError":"连接错误",
        "noVariables":"没有可用的数据",
        "noDevices":"无设备",
        "rollCallConfirm":"更新确认",
        "rollCallTitle":"更新当前页全部数据",
        "rollCallSuccess":"更新成功",
        "rollCallError":"更新异常",
        "currentValue":"当前值",
        "parmCount":"个参数",        
        "historyData":"时序曲线",        
        "RealTimePlot":"实时曲线",
        "XYPlot":"X-Y图象",
        "paginationSelect":"请选择",
        "paginationAll":"全部",
        "paginationPage":"条/页",
            "showAllData": "已显示全部 {count} 条数据",
      "selectVariableFirst": '请先在数据块上选择变量',
      "maxFiveVariables": '一次查询不能超10个变量',
      "historyDataTitle": '时序曲线 - {count}个变量',
      "realTimePlotTitle": '实时曲线 - {count}个变量',
      "X-YDataTitle": 'X-Y 图象 - {count} 个变量',
     "noVariablesConfirm": "您没有选择指定变量，将会更新全部变量，确认要这么做吗？",
           "confirmTitle": "确认操作",
           "trackingStarted":"数据更新开始",
           "trackingStopped":"数据更新停止",
               "updateAll":"刷新",
               "updateMode": "更新方式",
      "autoUpdate": "自动刷新",
      "manualUpdate": "手动刷新", 
      "updateInterval": "刷新间隔",
      "oneSecond": "1秒",
      "fiveSeconds": "5秒", 
      "tenSeconds": "10秒",
      "thirtySeconds": "30秒",
      "noUpdate": "不刷新",
      "customInterval": "自定义间隔",
      "enterInterval": "请输入间隔",
      "seconds": "秒",
      "updateInfo": "更新信息",
      "autoUpdateDesc": "基于设备上传频率自动更新数据",
      "minutes": "分钟",
      "durationTips": "设置更新的总持续时间",
      "trackingStatus": "更新状态",
      "trackingActive": "更新进行中",
      "remainingTime": "剩余时间",
      "currentInterval": "当前间隔",
      "tracking": "更新中...",
      "invalidInterval": "请设置有效的更新间隔",
      "setValueError": '设置值不在指定范围- 最小{minimum}-最大{maximum}',
      "invalidNumber":"无效数字",
      'invalidTime':"无效时间"
    },
    "ClientDeviceMonitorSystemMonitorSetup":
    {
        "setup":"设置",
        "sendSetup":"下发设置值",
        "currentValue":"当前值",
        "setupVlaue":"设置值",
        "description":"描述",                 
        "confirmSetValue": "确定要将 {title} 的值设置为 {value} {unit} 吗？",
      "confirmSet": "确认设置",
      "setSuccess": "参数 {title} 设置成功",
      "setFailed": "设置参数 {title} 失败: {error}",
      "connectError": "连接错误，请检查网络连接",
      "noVariables": "没有可设置的变量",
      "noDevices": "没有找到设备"
        
    },
    "ClientDeviceMonitorSystemDebug":
    {
        "hostDebug":"主机调试",
        "handDebug":"手动调试",
    },
    "ClientDeviceMonitorSystemDebugHostDebug":
    {
      "currentValue":"当前值",
      "setValue":"设置值",      
        "send":"设置",
        "confirmSetValue": "确定要将 {title} 的值设置为 {value} {unit} 吗？",
      "confirmSet": "确认设置",
      "setSuccess": "参数 {title} 设置成功",
      "setFailed": "设置参数 {title} 失败: {error}",
      "connectError": "连接错误，请检查网络连接",
      "noVariables": "没有可设置的变量",
      "noDevices": "没有找到设备"
    },
    "ClientDeviceMonitorSystemSettings":
    {
        "alarmReset":"报警重置",
        "executionPlan":"执行计划",
        "systemSettings":"系统设置",
    },
    "ClientDeviceMonitorSystemSettingsAlarmReset":
    {
        "reset":"重置",        
        "confirmRetset":   `确定要重置 {title} 吗？`,
        "confirmReset": "确认重置",
        "normal" :"正常",
        "alarm" :"异常",
            "locked": "锁定",
    "comm-error": "通讯错误",
    "reSetSuccess": "{title} 重置成功,{count}条",
    "resetFailed": "重置参数 {title} 失败: {error}",
    "errorDeviceCode": "目标变量与当前报警变量不在同一个设备上!",
    "noLinkageVars":"无联动变量,需要重置变量{name}?",
    },
    device: {
    "title": "设备管理",
    "add": "添加设备",
    "edit": "编辑",
    "view":"查看",
    "delete": "删除",
    "basicInfo": "基本信息",
    "networkSettings": "联网设置",
    "dataSettings": "数据设置",
    "name": "设备名称",
    "code": "设备编码",
    "company": "所属组织",
    "selectCompany": "选择组织",
    "description": "设备描述",
    "location": "设备位置",
    "gateway": "网关",
    "selectGateway": "选择网关",
    "template": "设备模板",
    "associatedDeviceTemplate": "关联设备模板",
    "selectTemplate": "选择模板",
    "slaveTotal": "从设备总数",
    "varTotal": "变量总数",
    "collectionType": "采集方式",
    "varName": "变量名",
    "valueType": "数值类型",
    "slave": "所属从设备",
    "state": "状态",    
     "offline": '离线',
      "online": '在线',
    "createTime": "创建时间",
    "actions": "操作",
    "search": "搜索",
    "reset": "重置",
    "inputName": "请输入设备名称",
    "nameRequired": "设备名称不能为空",
    "codeRequired": "设备编码不能为空",
    "companyRequired": "请选择所属组织",
    "gatewayRequired": "请选择网关",
    "selectTemplateFirst": "请先选择模板",
    "selectCompanyFirst": "请先选择组织",
    "addTitle": "添加设备",
    "editTitle": "编辑设备",
    "deleteConfirm": "确认删除设备 {name} 吗？",
    "deleteSuccess": "设备删除成功",
    "deleteFailed": "设备删除失败",
    "addSuccess": "设备添加成功",
    "updateSuccess": "设备更新成功",
    "submitError": "设备提交失败",
    "loadCompanyFailed": "加载组织列表失败",
    "loadGatewaysFailed": "加载网关列表失败",
    "loadTemplatesFailed": "加载模板列表失败",
    "loadTemplateFailed": "加载模板详情失败",
    "loadTemplateVarFailed": "加载模板变量详情失败",
    "cancel": "取消",
    "save": "保存",
    "confirm": "确定",
    "slaveName": "从设备名称",
  "serialPort": "串口序号",
  "slaveAddress": "从设备地址",
  "inputSerialPort": "请输入串口序号",
  "inputSlaveAddress": "请输入从设备地址",
  "serialSerialNumber": "串口序号",  
  "serialPortMustBeNumber": "串行端口必须是数字",
  "slaveAddressMustBeNumber": "从设备地址必须是数字",  
  "slaveConfig": "配置从设备"
  },
    reaTimePlot:{       
      "deviceVariableMonitor":"曲线趋势图",
      "ScatterTrendChart":"散点趋势图",
      "selectDevice":"请选择设备",
      "companyDeviceTree":"企业设备树",
      "monitorVariable":"监控变量",
      "selectVariable":"请选择变量",
      "loadDeviceTreeFailed":"获取设备树失败",
        "loadVariableListFailed":"获取变量列表失败",
        "VariableListNoData":"无变量数据",
      "SelectVarMax":"选择变量总数不能超10",
      "dataProcessError": "数据加载错误",
      "MonitoringDuration": "监控时长(小时)",
      "minute": "分钟",
      "hour": "小时",
       "time": "时间",
        "leaveConfirm": "正在监控数据，确定要离开吗？",
      "releasingSubscription": "正在释放数据订阅，请稍候...",
      "leaveError": "离开页面时发生错误",
      "releaseFailed": "释放订阅失败",
      "rollCall": "主动采集",
      "track": "刷新设置",
      "stopTrack":"停止更新",
      "trackingStopped":"更新已停止",
      "trackingCompleted": "更新已完成",
      "trackingStarted": "跟踪开始",      
      "interval":"上传间隔(秒)",      
      "duration":"持续时间(分钟)",
      "connectError": "连接异常",
      "reconnecting": "正在尝试重新连接 (第{attempts}次, {seconds}秒后重试)...",      
      "notEnoughMemory": "您的设备内存较低 ({memorys}GB)，可能影响数据处理性能",
      "exceed": "时间范围不能超过 ({val}小时)",
      "exceedDay": "时间范围不能超过 ({val}天)",
      "stopReceiving":"停止接收",
      "startReceiving":"开始接收",
      "receiving":"正在接收",
      "paused":"暂停接收",
      "dataReceivingPaused":"数据接收暂停",
      "dataReceivingResumed":"数据接收恢复",        
      "stopDataFirst":"请先停目数据接收"
    },
    realTimeData:{      
      "selectDevice":"请选择设备",
      "companyDeviceTree":"企业设备树",
      "slaveList":"从设备列表",
      "selectVariable":"请查询变量",
      "loadDeviceTreeFailed":"获取设备树失败",
        "loadVariableListFailed":"获取变量列表失败",
        "VariableListNoData":"无变量数据",      
      "dataProcessError": "数据加载错误",        
      "leaveError": "离开页面时发生错误",
      "releaseFailed": "释放订阅失败",
      "rollCall": "点名",
      "connectError": "连接异常",
      "reconnecting": "正在尝试重新连接 (第{attempts}次, {seconds}秒后重试)...",      
      "time" : "时间",
      "deviceName": "设备名称",
      "varname": "变量通讯名称",
      "display_name": "变量名称",
     "name_group": "变量分组",
      "Variable_description": "变量描述",
      "SlaveName":"从设备名称",
      "varType":"变量类型",
      "updateTime": "更新时间",
      "currentValue": "当前值",
      "unit": "单位",
      "setValue": "设置值",      
      "actions": "操作",
      "query": "查询",
      "activeCollection": "主动采集",
      "edit":"编辑",
      "valuePlaceholder":"请输入设置值",
      "SelectSalve": "选择从设备",
      "inputVarName":"请输入变量名称查询",
      "inputGroupName":"请输入变量分组名称查询",
      "selectVariableGroup":"选择变量分组（可多选）",
      "allGroups":"全部分组",
       "selectedGroups": "已选 {count} 个分组",      
      "editDialogTitle":"编辑",
      "hostOrganization":"所属组织:",
      "deviceTemplate":"设备模板:",
      "gateway":"设备网关:",
      "deviceAddress":"设备地址:",
      "deviceTags":"设备标签:",
      "deviceDescribe":"设备描述:",
            "columnSettings": "列设置",
      "selectColumns": "选择显示的列",
      "columnSettingsSaved": "列设置已保存",
      "showPagination":"分页",
            "loadingMore": "加载中...",
      "noMoreData": "没有更多数据了",
      "noData": "暂无数据",
      "loadMoreError": "加载更多数据失败",
          "lockScroll": '锁定滚动',
    "unlockScroll": '解锁滚动',
    "scrollLocked": '滚动已锁定',
    "scrollUnlocked": '滚动已解锁',
    "scrollLockedAlert": '滚动功能已锁定，不会自动加载新数据',
    "scrollLockedMessage": '滚动已锁定',
          "deviceInfo": "设备信息",      
      "expand":"展开",
      "collapse":"折叠",
      "selectDeviceOnly":"只能选中设备",
    },
    "historyRecord":
    {
      "points": " 点",
      "selectXAxisVariableFirst": "请先选择X轴变量",
           "xAxisVarNotFound": "未找到X轴变量 {name} 对应的设备配置",
      "queryDataSuccess": "查询到 {count} 条历史数据，共 {days} 天",
            "noValidXAxisData": "没有找到有效的X轴数据",
      "query":"刷新",      
        "reset":"重置",        
        "selectTimeRange":"请选择时间范围",
        "queryFailed":"查询失败",
        "queryError":"查询异常",
        "loadMore":"加载更多",
        "noMoreData":"没有更多数据",
        "processError":"过程错误",
        "queryCompleted":"查询已完成",                 
        "timeRange":"用户选择",
         "today" : "今天",
         "yesterday":"昨天",         
         "sevenDays":"7天",         
         "24hour" : "24小时",
         "startTime":"开始时间",
        "endTime":"结束时间",
        "quickTime":"查询时间",
        "selectTime": "选择时间",
        "exportVariables":"数据下载",
        "exportSuccess": "导出成功",
      "exportFailed": "导出失败",
      "exportError": "导出错误",
      "exportDataError": "响应不是有效的文件数据",
        "noData":"无数据",
        "selectVariables":"请选择变量",
        "aggregateData":"数据已聚合 {total} 个数",
        "timeTip":"查询24小时设备时间失败,使用当前计算机时间查询",
         "yAxisControl": "X-Y轴范围控制",           
         "showAllXAxisSettings": "显示X轴设置",
      "showAllYAxisSettings": "显示所有Y轴设置",
      "clearAllYAxisRanges": "清除所有Y轴范围",
      "clearAllXAxisRanges": "清除X轴范围",
      "yAxisRangeManagement": "Y轴范围管理",
      "xAxisRangeManagement": "x轴范围管理",
      "setYAxisRange": "设置 {name} Y轴范围",
      "setXAxisRange": "设置X轴范围",
      "xResetAuto": "重置",
      "minValue": "最小值",
      "maxValue": "最大值",
      "xAxisPointCount":"X轴:",
      "invalidRange": "请输入有效的数值范围",
      "minGreaterThanMax": "最小值不能大于等于最大值",
      "rangeSetSuccess": "Y轴范围设置成功",
      "rangeXSetSuccess": "X轴范围设置成功",
      "rangeXResetSuccess": "X轴范围已重置",
      "rangeResetSuccess": "Y轴范围已重置",
      "allRangesCleared": "所有Y轴范围已清除",
      "XRangesCleared": "X轴范围已清除",
      "manual": "手动",
      "auto": "自动",      
      "cancel":"取消",
      "confirm":"确定",
        "timeMode":"时间模式",
        "variableMode":"变量模式",
        "selectXAxisVariable":"选择X轴变量",
          "startTimer": "开始时间",
      "endTimer": "结束时间",
       "placeholderStartTimer": "请选择开始时间",
          "placeholderEndTimer": "请选择开始时间",      
          "xAxisRangeSetSuccess": "X轴范围已设置为 {min} 至 {max}",
                "selectValidTimeRange": "请选择有效的时间范围",
      "startTimeLessThanEndTime": "开始时间必须小于结束时间",
      "multiTimeRange": "多时段",
      "multiTimeRangeManagement": "多时段管理",
      "multiTimeRangeTip": "可以添加多个时间区间，数据将合并显示在图表中",
      "multiTimeRangeSet": "已设置 {count} 个时段",
      "noValidTimeRange": "没有有效的时间范围",
      "timeRangeSections":"时间范围区段",
      "addTimeSection":"添加时间段",
      "section":"时段",
      "queryDataSuccessMulti":"查询数据共计:{count}条，{sections} 段, {hours}小时",
      "delete":"删除",
      "sectionDeleted":"删除时段",
      "sectionAdded":"增加时段",
      "controlNo":"多时段,X轴不可控制",      
"xAxisPaddingControl":"X轴边界控制",
 "leftPadding":"左边距",
"rightPadding":"右边距",
"resetPadding":"重置",
"paddingTip":"通过左右边距设置控制图象",
"sectionGap": "图象间隙",
      "stopDataFirst":"请先停目数据接收",
        oneYear: '一年',
    trendCalc: '趋势运算',
    trendOn: '趋势',
    trendOff: '原始',
    maxPoints: '最多点数',
    autoPoints: '自动',
    aggregateStep: '聚合步长',
    stepRaw: '原始数据',
    step1min: '1分钟',
    step5min: '5分钟',
    step10min: '10分钟',
    step20min: '20分钟',
    step1h: '1小时',
    step1d: '1天',
    aggregateType: '聚合方式',
    aggAvg: '平均值',
    aggMax: '最大值',
    aggMin: '最小值',
    aggFirst: '首值',
    aggLast: '末值',
    autoLoadOnZoom: '扩大图自动加载',
    on: '开',
    off: '关',
    enlarge: '扩大图',
    exitEnlarge: '退出扩大图',
    "fullDayMode":"整天模式",
    "tooManyVariablesForLongRange": '查询时间超过 {days} 天时，最多只能选择 {max} 个变量',
"longRangeVarLimitTip": '查询超过 30 天时最多选 3 个变量'
    },
    CompDeviceTree:{
      "searchDevice":"搜索设备",
    },
      varableSelectorControl:{       
      "pleaseSelect":"请选择",
      "totalCount":"共 {total} 条",
      "slaveList": "从设备列表",
    "inputSlaveName": "请输入从设备名称",
    "allSlaves": "全部从设备",  
    "variableList": "变量列表",
    "searchVariable": "搜索变量",  
      "selectDeviceFirst": "请先选择设备",
      "selectVariableFirst": "请先选择变量",      
      "noVariableData": "没有变量数据",    
      "loadSlaveFailed": "加载从设备列表失败",
      "loadVariableFailed": "加载变量列表失败",
      "selectAll":"全选",
      "unselectAll":"取消选择",
      "loadGroupFailed":"加载组失败"
    },    
    "ClientProjectDeailAdd": {
        // 项目信息配置相关
        "projectInfoConfig": "项目信息配置",
        "projectName": "项目名称",
        "enterProjectName": "请输入项目名称",
        "projectOptions": "项目选项",
        "selectBusiness": "请选择业务",
        "projectDescription": "项目描述",
        "projectSort":"排序",
        "enterProjectDescription": "请输入项目描述",
        "projectLocation": "项目位置",
        "enterProjectLocation": "请输入项目位置",
        
        // 参数模块相关
        "parameterModule": "参数模块",
        "parameterOptions": "参数选项",
        "selectParameterOptions": "请选择参数选项",
        "parameterModuleName": "参数模块名称",
        
        // 变量相关
        "id" :"序号",
        "deviceId": "设备序号",
        "variableName": "变量名称",
        "deviceName": "设备名称",
        "displayName": "显示名称",
        "variableValue": "变量值",
        "unit": "单位",
        "sort":"排序",
        "operations": "操作",
        "addVariable": "添加变量",
        "importVariables": "导入变量",
        "refreshVariables": "刷新变量",
        "queryingVariables": "正在查询变量...",
        "refreshVariableList": "刷新变量列表",
        "exportVariables": "导出变量",
        "batchDelete": "批量删除",
        "search": "查询",
        "save": "保存",
        "variableGroup": "变量分组",
        "variableDetails": "变量详情",
        "variableType": "变量类型",
        "readWriteType": "读写类型",
        "defaultValue": "默认值",
        "coefficient": "系数",
        "valueRange": "值范围",
        "decimalPlaces": "小数位",
        "description": "描述",
        "noDescription": "无描述",
        "viewDetails": "查看详情",
        "removeFromSelection": "从选择中移除",
        "addToSelection": "添加到选择",
        "searchPlaceholder": "搜索变量名称、显示名或描述",
        "selectVariableGroup": "请选择变量分组",
        "enterVariableName": "请输入变量名称",
        "enterDisplayName": "请输入显示名称",
              "unnamedVariable": "未命名变量",
      "removeLinkageVariable": "移除联动变量",
      "addToLinkage": "添加到联动",
      "variableAlreadyInLinkage": "变量已在联动列表中",
      "variableAddedToLinkage": "变量已添加到联动列表",
      "confirmRemoveLinkageVariable": "确定要移除这个联动变量吗？",      
      "linkageVariableRemoved": "联动变量已移除",
      "linkageVariableRemovedFailed": "联动变量移除失败",
      "selectLinkageVariables": "请先选择要联动的变量",
      "linkageSavedSuccess": "联动规则保存成功",
      "linkagePartialFailed": "部分联动规则保存失败",
      "removeLinkagedVariable": "有绑定,请先删除绑定变量",
        // 对话框相关
        "prompt": "提示",
        "confirm": "确定",
        "cancel": "取消",
        "editVariable": "编辑变量",
        "addLinkageRule": "添加联动规则",
        "editLinkageRule": "编辑联动规则",
        "close": "关闭",
        
        // 联动规则相关
        "linkageType": "联动类型",
        "fixedValueDispatch": "固定值下发",
        "multiVariableLinkage": "多变量联动",
        "formulaCalculation": "公式计算",
        "triggerCondition": "触发条件",
        "executeImmediately": "立即执行",
        "delayedExecution": "延迟执行",
        "executeWhenConditionMet": "条件满足执行",
        "targetVariableId": "目标变量ID",
        "delayTime": "延迟时间(秒)",
        "triggerConditionExpression": "触发条件表达式",
        "expressionExample": "例如: var1 > 100 && var2 < 50",
        "linkageContent": "联动内容",
        "contentExample": "例如: 100",
        "linkageFormula": "联动公式",
        "formulaExample": "例如: var1 * 2 + var2",
        "ruleDescription": "规则描述",
        "enterRuleDescription": "请输入规则描述",
        
        // 企业设备树相关
        "companyDeviceTree": "企业设备树",
        "selectDevice": "选择设备",
        "slaveList": "从机列表",
        "selectSlave": "选择从机",
        "allSlaves": "所有从机",
        "allGroups": "所有分组",
        "enterVariableNamePlaceholder": "请输入变量名",
        
        // 表格相关
        "belongingDevice": "所属设备",
        
        // 成功消息
        "projectSavedSuccess": "项目保存成功",
        "projectUpdatedSuccess": "项目更新成功",
        "parameterModuleSavedSuccess": "参数模块保存成功",
        "parameterModuleUpdatedSuccess": "参数模块更新成功",
        "currentModuleSaved": "当前参数模块已保存",
        "parameterModuleAddedSuccess": "参数模块添加成功",
        "savedSuccess": "保存成功",
        "variableDeletedSuccess": "变量删除成功",
        "deletedSuccess": "删除成功",
        "successfullyDeleted": "成功删除",
        "querySuccessfulFound": "查询成功，找到",
        "variables": "个变量",
        "successfullyBatchBound": "成功批量绑定",
        "variablesToProject": "个变量到项目",
        "updatedSuccess": "更新成功",
        "addedSuccess": "添加成功",
        
        // 警告消息
        "completeAllModules": "请完善所有业务块配置",
        "completeCurrentModule": "请完善当前参数模块配置",
        "keepAtLeastOneModule": "至少保留一个参数模块",
        "selectModuleFirst": "请先选择一个参数模块",
        "saveModuleFirst": "请先保存参数模块",
        "saveProjectFirst": "请先保存项目",
        "noMatchingVariables": "未找到匹配的变量",
        "selectDeviceFirst": "请先选择设备",
        "selectVariablesFirst": "请先选择变量",
        "allVariablesExist": "所有选择的变量都已存在于项目中",
        "noValidVariables": "没有有效的变量需要处理",
        "allDeletionsFailed": "所有删除操作均失败",
        "fillProjectName": "请填写项目名称",
        "fillProjectCompanyId": "请选择企业",
        "fillModuleName": "请填写参数模块名称",
        "checkFormData": "请检查表单数据",
        
        // 错误消息
        "batchDeleteFailed": "批量删除失败",
        "errorDuringDeletion": "删除过程中发生错误",
        "moduleUpdateFailed": "参数模块更新失败",
        "moduleSaveFailed": "参数模块保存失败",
        "moduleDeleteFailed": "参数模块删除失败",
        "addFailed": "添加失败",
        "saveFailed": "保存失败",
        "importFailed": "导入失败",
        "exportNotImplemented": "导出变量功能待实现",
        "errorSavingProject": "保存项目时出错",
        "errorSavingModule": "保存参数模块时出错",
        "deleteFailed": "删除失败",
        "deleteApiFailed": "调用删除接口失败",
        "batchBindingFailed": "批量绑定失败",
        "errorDuringBatchBinding": "批量绑定过程中发生错误",
        "queryVariablesFailed": "查询变量失败",
        "queryFailed": "查询失败",
        "loadSlavesFailed": "加载从机失败",
        "loadGroupsFailed": "加载变量分组失败",
        "loadDeviceTreeFailed": "加载设备树失败",
        "loadBusinessFailed": "加载业务选项失败",
        
        // 确认对话框消息
        "confirmDeleteModule": "确定删除该参数模块吗？",
        "confirmDeleteVariable": "确定删除该变量吗？",
        "confirmDeleteSelected": "确定删除选中的",
        "confirmDeleteVariables": "个变量吗？",
        "device": "设备",
        "variableDeletionFailed": "的变量删除失败",
        "unknownError": "未知错误",
        "apiCallException": "接口调用异常",
        
        // 状态和操作文本
        "selected": "已选择",
        "currentPageSelection": "当前页选择",
        "deviceVariablesFailed": "个设备的变量删除失败",
        "deleted": "已删除",
        "success": "成功",
        "failed": "失败",
        "variableUniqueIdentifier": "变量唯一标识符",
        "removedVariable": "已移除变量",
        "addedVariable": "已添加变量",
        "addedToSelectionList": "已添加到选择列表",
        "clearAllSelections": "清空所有选择",
        
        // 业务类型和参数选项
        "operatingParameters": "运行参数",
        "alarms": "报警",
        "systemSettings": "系统设置",
        
        // 功能块相关
        "submitProject": "提交项目",
        "reset": "重置",
        "previewConfig": "预览配置",
        "functionBlock": "功能块",
        "configPreviewConsole": "配置预览已输出到控制台",
        "moduleCount": "业务块数量",
        "functionBlockCount": "功能块数量",
        "variableBindingCount": "变量绑定数量",
        "linkageRuleCount": "联动规则数量",
        
        // 特殊文本
        "placeholder": "--",
        "none": "无",
        "ungrouped": "未分组",
        "unknownParameter": "未知参数",
        "basicInfo": "基本信息",
        "valueConfig": "数值配置",
        "processVariableDataFailed": "处理变量数据失败",
        "noVariablesToBind": "没有需要绑定的变量",
        "variablesExist": "个变量已存在",
        "variablesInfo": "个变量的信息",
        "notSelected": "未选择",
        "configPreview": "配置预览",
        "validationFailed": "验证失败",
        "formValidationFailed": "表单验证失败",
        "boundVariable":"已绑定变量",
        "noBoundVariable":"无绑定变量",
        "searchVariable":"搜索变量",
        "searchVariablePlaceholder":"请输入变量名",
        "variableList":"变量列表",
        "cannotMoveUp": "已经是第一个，无法上移",
      "cannotMoveDown": "已经是最后一个，无法下移",
      "moveUpSuccess": "上移成功",
      "moveUpFailed": "上移失败",
      "moveDownSuccess": "下移成功",
      "moveDownFailed": "下移失败",
      "sortUpdateSuccess": "排序更新成功",
      "sortUpdateFailed": "排序更新失败",
      
      "sortMinValue": "排序值不能小于1",
      "sortMaxValue": "排序值不能大于9999",
      "sortConflict": "排序值与其他变量冲突",
      "batchSortUpdateSuccess": "批量排序更新成功",
      "batchSortUpdateFailed": "批量排序更新失败",
      "noSortChanges": "没有需要更新的排序",
      "reorderSort": "重新排序",
      "exportCurrentPage":"导出本页",
      "importSort":"导入排序",
            
      "noDataToExport": "没有数据可导出",
      "exportSuccess": "导出成功",
      "exportFailed": "导出失败",
      "noDataInFile": "文件中没有数据",
      "noValidSortData": "没有有效的排序数据",
      "confirmImportSort": "确认导入排序数据吗？这将更新当前页中匹配的变量排序。",
      "importCount": "导入数量",
      "importSuccess": "导入成功，更新了",
        "resetSort": "重置排序",
      "noDataToReset": "当前没有数据需要重置",
      "confirmResetSort": "确认将当前列表中所有变量的排序重置为0吗?",
      "resetSortSuccess": "重置排序成功，已重置",
      "resetSortFailed": "重置排序失败",
      "projectGroup":"项目组",
      "selectOrEnterProjectGroup":"选择或输入项目组"
      }
    // 其他翻译...
  }
}